(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-header"] && !Shopify.designMode) return;
  try {
    
  var ActivityHeader = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const button = this.querySelector('.header-button');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', 'UkPCfK']);
        });
      }
    }
  };
  if (!window.customElements.get('activity-header')) {
    window.customElements.define('activity-header', ActivityHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-main-slide-bf"] && !Shopify.designMode) return;
  try {
    
  var PromptMainSlider = class extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    isMobile() {
      const mediaQuery = '(max-width: 768px)';
      const mql = window.matchMedia(mediaQuery);
      return mql.matches;
    }

    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.pc-swiper-' + id;
      let paginationClassname = '.pc-pagination-' + id;

      if (this.isMobile()) {
        className = '.mobile-swiper-' + id;
        paginationClassname = '.mobile-pagination-' + id;
      }

      const slideCount = this.querySelectorAll(className + ' .swiper-slide').length;
      if (slideCount <= 1) return;

      const speed = this.dataset.speed || 3;

      this.swiper = new Swiper(className, {
        loop: true,
        autoplay: {
          delay: speed * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        pagination: {
          el: paginationClassname,
          clickable: true,
        }
      });
    }

    connectedCallback() {
      this.initSwiper();
    }
  };

  if (!window.customElements.get('activity-main-slide')) {
    window.customElements.define('activity-main-slide', PromptMainSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-main-slide"] && !Shopify.designMode) return;
  try {
    
  var PromptMainSlider = class extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    isMobile() {
      const mediaQuery = '(max-width: 768px)';
      const mql = window.matchMedia(mediaQuery);
      return mql.matches;
    }

    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.pc-swiper-' + id;
      let paginationClassname = '.pc-pagination-' + id;

      if (this.isMobile()) {
        className = '.mobile-swiper-' + id;
        paginationClassname = '.mobile-pagination-' + id;
      }

      const speed = this.dataset.speed || 3;

      this.swiper = new Swiper(className, {
        loop: true,
        autoplay: {
          delay: speed * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        spaceBetween: 20,
        slidesPerView: 1,
        pagination: {
          el: paginationClassname,
          clickable: true,
        }
      });
    }

    connectedCallback() {
      this.initSwiper();
    }
  };

  if (!window.customElements.get('activity-main-slide')) {
    window.customElements.define('activity-main-slide', PromptMainSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-menu"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function setActivityMenuCartCount(count) {
    const cartCounts = document.querySelectorAll('#lj-menu [data-activity-menu-cart-count]');
    const safeCount = Number(count);

    cartCounts.forEach((countEl) => {
      countEl.textContent = Number.isFinite(safeCount) ? String(safeCount) : '0';
    });
  }

  function updateActivityMenuCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      }
    })
      .then((response) => response.json())
      .then((cart) => {
        setActivityMenuCartCount(cart && cart.item_count);
        return cart;
      })
      .catch((error) => {
        console.error('Failed to update activity-menu cart count:', error);
      });
  }

  function syncCartCountWithRetry() {
    const delays = [200, 500, 900, 1400];

    delays.forEach((delay) => {
      setTimeout(() => {
        updateActivityMenuCartCount();
      }, delay);
    });
  }

  updateActivityMenuCartCount();

  document.addEventListener('cart:refresh', updateActivityMenuCartCount);
  document.addEventListener('cart:updated', updateActivityMenuCartCount);
  document.addEventListener('product:added', updateActivityMenuCartCount);

  document.addEventListener('click', function (event) {
    const addToCartButton = event.target.closest(
      'button[name="add"], button[type="submit"][name="add"], .product-form__submit, .add-to-cart'
    );

    if (addToCartButton) {
      syncCartCountWithRetry();
    }
  });

  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      try {
        const requestUrl = arguments[0];
        const url = typeof requestUrl === 'string' ? requestUrl : requestUrl.url;

        if (url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
          syncCartCountWithRetry();
        }
      } catch (e) {}

      return response;
    });
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._activityMenuUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      try {
        const url = this._activityMenuUrl || '';

        if (
          url.indexOf('/cart/add') !== -1 ||
          url.indexOf('/cart/change') !== -1 ||
          url.indexOf('/cart/update') !== -1
        ) {
          syncCartCountWithRetry();
        }
      } catch (e) {}
    });

    return originalSend.apply(this, arguments);
  };
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-picture-redirect"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('activity-picture-redirect')) {
    class ActivityPictureRedirect extends HTMLElement {
      constructor() {
        super();
        this.buttonsWrapper = this.querySelector('.feature-buttons-wrapper');
        this.imageContainers = this.querySelectorAll('.feature-image-container');
      }

      connectedCallback() {
        if (!this.buttonsWrapper || !this.imageContainers) return;
        this.initButtonEvent();
        this.setInitialState();
      }

      setInitialState() {
        const firstButton = this.buttonsWrapper.querySelector('.feature-button');
        if (firstButton) {
          firstButton.classList.add('active');
          const initialBlockId = firstButton.getAttribute('data-block-id');
          this.showTargetImage(initialBlockId);
        } else {
           if(this.imageContainers.length > 0) {
              this.imageContainers[0].classList.add('active');
           }
        }
      }

      clearActiveButtonStatus() {
        const buttons = this.buttonsWrapper.querySelectorAll('.feature-button');
        buttons.forEach(btn => btn.classList.remove('active'));
      }

      clearImageActiveStatus() {
        this.imageContainers.forEach(container => container.classList.remove('active'));
      }

      showTargetImage(blockId) {
        if (!blockId) return;
        this.clearImageActiveStatus();
        const targetImage = this.querySelector(`#image-${blockId}`);
        if (targetImage) {
          targetImage.classList.add('active');
        }
      }

      initButtonEvent() {
        this.buttonsWrapper.addEventListener('click', (event) => {
          const clickedButton = event.target.closest('.feature-button');
          if (!clickedButton || clickedButton.classList.contains('active')) {
            return;
          }

          this.clearActiveButtonStatus();
          clickedButton.classList.add('active');
          const block_id = clickedButton.getAttribute('data-block-id');
          this.showTargetImage(block_id);
        });
      }
    }
    window.customElements.define('activity-picture-redirect', ActivityPictureRedirect);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-product-card"] && !Shopify.designMode) return;
  try {
    
  function ljThrottle(func, delay) {
    let timer = null;
    return function () {
      const context = this;
      const args = arguments;
      if (!timer) {
        timer = setTimeout(() => {
          func.apply(context, args);
          timer = null;
        }, delay);
      }
    };
  }
  class PromptProductCard extends HTMLElement {
    constructor() {
      super();
      // No swipers needed for this card logic
      // this.swipers = new Map();
      this.priceWrappers = null; // Keep if price offer logic is still used elsewhere
      this.minDiff = 56; // Keep if price offer logic is still used
       // Use arrow function to preserve 'this' context or bind later
       this.handleSizeChange = this.handleSizeChange.bind(this);
       this.init = this.init.bind(this); // Ensure init uses correct 'this'

       if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.init);
       } else {
        this.init(); // Already loaded
       }
    }

    connectedCallback() {
        // Init is called via DOMContentLoaded or directly in constructor
        console.log('activity-product-card connected');
    }

    init() {
      console.log('PromptProductCard init called.');
      // Note: 'this' refers to the <activity-product-card> element
      const productCards = this.querySelectorAll('li[data-product-id]');
      console.log('Found product cards inside custom element:', productCards.length);

      if (productCards.length === 0) {
        console.warn('No product cards found within activity-product-gallery.');
        return;
      }

      productCards.forEach((card) => {
        const productId = card.dataset.productId;
        const swatchesContainer = card.querySelector('[data-color-swatches]');
        const variantJsonScript = card.querySelector(`script[data-variant-json="${productId}"]`);
        let variantsData = [];

        console.log(`Processing card ${productId}`);

        if (variantJsonScript) {
          try {
            variantsData = JSON.parse(variantJsonScript.textContent);
            console.log(`Parsed ${variantsData.length} variants for product ${productId}`);
            if(variantsData.length === 0){
                 console.warn(`No variant data parsed for product ${productId}`);
                 return; // Skip if no variants
            }
          } catch (e) {
            console.error(`Error parsing variant JSON for product ${productId}:`, e);
            return; // Skip this card
          }
        } else {
          console.warn(`Variant JSON script not found for product ${productId}`);
          return; // Skip this card
        }

        // --- Initial Card State Setup ---
        const productCardElement = card.querySelector('.product-gallery-card');
        if (!productCardElement) {
          console.error('Could not find .product-gallery-card inside li for product', productId);
          return; // Skip if card structure is wrong
        }

        // Find the initially active swatch (set by Liquid)
        const initialActiveSwatch = swatchesContainer?.querySelector('.color-swatch.active');
        const initialVariantId = initialActiveSwatch?.dataset.variantId;

        let initialVariant = null;
        if (initialVariantId) {
            initialVariant = variantsData.find((v) => v.id == initialVariantId);
            if (initialVariant) {
                console.log(`Initial update for product ${productId} with variant ${initialVariantId} (from active swatch)`);
                this.updateCard(productCardElement, initialVariant);
            } else {
                 console.warn(`Could not find initial variant data for active swatch ID: ${initialVariantId} in product ${productId}. Falling back.`);
                 initialVariant = variantsData[0]; // Fallback to first
                 if(initialVariant) this.updateCard(productCardElement, initialVariant);
            }
        } else if (variantsData.length > 0) {
            console.warn(`No active swatch found for product ${productId}, using first variant as initial.`);
            initialVariant = variantsData[0]; // Fallback to first variant if none active
            this.updateCard(productCardElement, initialVariant);
        } else {
             console.error(`No variants available to set initial state for product ${productId}`);
        }

        // --- Bind Add to Cart Event ---
        const addToCartBtn = card.querySelector('[data-add-to-cart]');
        if (addToCartBtn && !addToCartBtn.hasClickListener) {
          addToCartBtn.addEventListener('click', (e) => {
            e.preventDefault();
            const variantId = addToCartBtn.dataset.selectedVariantId;
            if (variantId) {
              this.addToCart(variantId, addToCartBtn);
            }
          });
          addToCartBtn.hasClickListener = true;
        }

        // --- Add Event Listeners ---
        if (swatchesContainer && variantsData.length > 0) {
          console.log(`Adding click listener to swatches for product ${productId}`);
          // Use bind to ensure 'this' inside the handler refers to the class instance
          swatchesContainer.addEventListener(
            'click',
            this.handleSwatchClick.bind(this, variantsData)
          );
        } else {
          console.log(`No swatches container or no variants for product ${productId}, listener not added.`);
        }
      });

       // Init resize listener if price offer logic is used
      // this.priceWrappers = this.querySelectorAll('.price-offers-wrapper'); // Adjust selector if needed
      // if (this.priceWrappers && this.priceWrappers.length > 0) {
      //   this.initEvent();
      // }
    }

    handleSwatchClick(variantsData, event) {
      const targetSwatch = event.target.closest('.color-swatch');
      if (!targetSwatch) return; // Exit if click wasn't on a swatch

      // Prevent re-updating if already active
      if (targetSwatch.classList.contains('active')) {
        console.log('Clicked swatch is already active.');
        return;
      }


      const clickedVariantId = targetSwatch.dataset.variantId;
      const swatchesContainer = targetSwatch.closest('[data-color-swatches]'); // Find container again
      const productCardElement = targetSwatch.closest('.product-gallery-card'); // Find card element

      console.log(`Swatch clicked! Variant ID: ${clickedVariantId}`);

      const selectedVariantData = variantsData.find((v) => v.id == clickedVariantId);

      if (selectedVariantData && productCardElement && swatchesContainer) {
        console.log('Found variant data:', selectedVariantData);

        // Update active class
        swatchesContainer.querySelectorAll('.color-swatch').forEach((sw) => sw.classList.remove('active'));
        targetSwatch.classList.add('active');
        console.log('Active class updated.');

        // Update the card content using the class method
        this.updateCard(productCardElement, selectedVariantData);

        // --- Update Modal Button OnClick ---
        const modalButton = productCardElement.querySelector('.product-gallery-card__button');
        const productHandle = modalButton?.getAttribute('onclick')?.match(/'([^']+)'/)?.[1]; // Extract handle
        const productType = modalButton?.getAttribute('onclick')?.match(/'([^']+)',\s*\d+,\s*'([^']*)'/)?.[2]; // Extract type if present

        if (modalButton && productHandle) {
            const newOnClick = `window.openProductModal('${productHandle}', ${selectedVariantData.id}${productType ? `, '${productType}'` : ''})`;
            console.log('Updating modal button onclick to:', newOnClick);
            modalButton.setAttribute('onclick', newOnClick);
        } else {
             console.warn('Could not update modal button onclick attribute.');
        }

        // --- Update Add to Cart Button Variant ID ---
        const addToCartBtn = productCardElement.querySelector('[data-add-to-cart]');
        if (addToCartBtn) {
            addToCartBtn.dataset.selectedVariantId = selectedVariantData.id;
        }

      } else {
        console.warn(`Could not find variant data, card element, or swatches container for ID: ${clickedVariantId}`);
      }
    }

    // --- Helper: Add to Cart (AJAX) ---
    addToCart(variantId, button) {
      const originalContent = button.innerHTML;
      button.disabled = true;
      button.innerHTML = '<span>Adding...</span>';

      let formData = {
        'items': [{
          'id': variantId,
          'quantity': 1
        }]
      };

      fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(data => {
        console.log('Added to cart:', data);
        button.innerHTML = '<span>Added!</span>';
        
        // Trigger Shopify cart update events
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        setTimeout(() => {
          button.innerHTML = originalContent;
          button.disabled = false;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error:', error);
        button.innerHTML = originalContent;
        button.disabled = false;
        alert('Failed to add to cart. Please try again.');
      });
    }

    // --- Helper: Format Money (Class method) ---
    formatMoney(cents, format) {
      if (typeof cents == 'string') {
        cents = cents.replace('.', '');
      }
       if (cents === null || typeof cents === 'undefined') {
           return ''; // Return empty string for null/undefined price
       }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
       // Use Shopify's format if available, otherwise a sensible default
      const formatString = format || window.Shopify?.currency?.money_format || '${{amount}}';

      function defaultOption(opt, def) {
        return typeof opt == 'undefined' ? def : opt;
      }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
          return "0"; // Return "0" instead of 0
        }
        number = (Number(number) / 100.0).toFixed(precision); // Ensure number conversion
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsValue = parts[1] ? decimal + parts[1] : ''; // Use different var name
        return dollars + centsValue;
      }
       try {
            let amountType = formatString.match(placeholderRegex)?.[1] || 'amount'; // Default to 'amount'
             switch (amountType) {
                 case 'amount':
                    value = formatWithDelimiters(cents, 2); break;
                 case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0); break;
                 case 'amount_with_comma_separator':
                     value = formatWithDelimiters(cents, 2, '.', ','); break;
                 case 'amount_no_decimals_with_comma_separator':
                     value = formatWithDelimiters(cents, 0, '.', ','); break;
                 // Add other Shopify formats if needed
                 default: value = formatWithDelimiters(cents, 2);
            }
            return formatString.replace(placeholderRegex, value);
        } catch (e) {
             console.error("Error formatting money:", e);
             // Fallback to simple formatting if complex regex fails
             return formatWithDelimiters(cents, 2);
        }
    }

    // --- Helper: Calculate Discount (Class method) ---
    calculateDiscount(price, compareAtPrice) {
      console.log(`Calculating discount: Price=${price}, CompareAtPrice=${compareAtPrice}`);
      const numPrice = Number(price);
      const numCompareAtPrice = Number(compareAtPrice);

      // Ensure compare_at_price is valid and greater than price
      if (
        numCompareAtPrice &&
        !isNaN(numCompareAtPrice) &&
        numPrice &&
        !isNaN(numPrice) &&
        numCompareAtPrice > numPrice
      ) {
        const diff = numCompareAtPrice - numPrice;
        const discount = Math.floor((diff * 100) / numCompareAtPrice);
        console.log('Discount calculated:', discount);
        return discount;
      }
      console.log('No discount applicable or invalid prices.');
      return 0;
    }

    // --- Update Card Function (Class method) ---
    updateCard(cardElement, selectedVariantData) {
      console.log('updateCard called for variant:', selectedVariantData?.id, 'Data:', selectedVariantData);
      if (!selectedVariantData || !cardElement) {
        console.error('updateCard called with invalid data or card element');
        return;
      }

      // Update Image
      const img = cardElement.querySelector('[data-main-image]');
      if (img) {
        if (selectedVariantData.image_src) {
          console.log('Updating image src to:', selectedVariantData.image_src);
          img.src = selectedVariantData.image_src;
          img.alt = selectedVariantData.image_alt || '';
          // Optional: Add fade effect
          img.style.opacity = 0;
          setTimeout(() => { img.style.opacity = 1; }, 50); // Small delay for fade-in
        } else {
          console.warn('No image_src found in variant data for image update.');
           img.src = '{{ "product-1" | placeholder_svg_tag }}'; // Placeholder
           img.alt = 'Placeholder image';
        }
      } else {
        console.warn('Image element [data-main-image] not found.');
      }

      // Update Price
      const priceWrapper = cardElement.querySelector('[data-price-display]');
      if (priceWrapper) {
        const currentPriceFormatted = this.formatMoney(selectedVariantData.price);
        let priceHTML = `<p class="price">${currentPriceFormatted}`;

        if (selectedVariantData.compare_at_price && Number(selectedVariantData.compare_at_price) > Number(selectedVariantData.price)) {
          const comparePriceFormatted = this.formatMoney(selectedVariantData.compare_at_price);
          priceHTML += ` <del>${comparePriceFormatted}</del>`;
        }

        priceHTML += `</p>`;
        console.log('Updating price display HTML to:', priceHTML);
        priceWrapper.innerHTML = priceHTML;
      } else {
        console.warn('Price element [data-price-display] not found.');
      }

      // Update Discount Badge
      const badgeContainer = cardElement.querySelector('[data-badge-container]');
      const badgeText = cardElement.querySelector('[data-badge-text]');
      if (badgeContainer && badgeText) {
        const discount = this.calculateDiscount(selectedVariantData.price, selectedVariantData.compare_at_price);
        if (discount > 0) {
          console.log(`Applying visible badge with text: ${discount}% OFF`);
          badgeText.textContent = `${discount}% OFF`; // Or just discount%
          badgeContainer.classList.add('visible');
        } else {
          console.log('Hiding badge (discount <= 0).');
          badgeText.textContent = '';
          badgeContainer.classList.remove('visible');
        }
      } else {
        console.warn('Badge container [data-badge-container] or text [data-badge-text] element not found.');
      }

      // Update Buy Button data-variant-id (href might not be needed if using modal)
      const buyButton = cardElement.querySelector('.product-gallery-card__button'); // Target the actual button
      if (buyButton) {
        // We update the onclick in handleSwatchClick now, no need to update href if it opens a modal
        console.log('Buy button variant ID association updated (via onclick update)');
      } else {
        console.warn('Buy button .product-gallery-card__button not found.');
      }
    }

    handleSizeChange() {
      // Keep this method if the .price-offers logic is still relevant
      console.log('handleSizeChange called - implement logic if needed');
      if (!this.priceWrappers || this.priceWrappers.length === 0) return;
      this.priceWrappers.forEach((wrapper) => {
        const wrapperRect = wrapper.getBoundingClientRect();
        const price = wrapper.querySelector('.price');
        if (!price) return;
        const priceRect = price.getBoundingClientRect();
        const diff = wrapperRect.width - priceRect.width;
        const target = wrapper.querySelector('.price-offers');
         if (!target) return;

        if (diff < this.minDiff) {
          const newDiff = this.minDiff - diff;
          const right = -28 + newDiff / 2;
          target.style.right = `${right}px`;
        } else {
          target.style.right = `-28px`;
        }
      });
    }

    initEvent() {
       // Use the throttled function
      const throttledResizeHandler = ljThrottle(this.handleSizeChange, 500);
      window.addEventListener('resize', throttledResizeHandler);
      console.log('Resize event listener initialized.');
    }

    // Removed initSwiper as it's not used in this component's logic
  }

  // Define the custom element if it hasn't been defined already
  if (!customElements.get('activity-product-card')) {
     customElements.define('activity-product-card', PromptProductCard);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-product-gallery"] && !Shopify.designMode) return;
  try {
    
if (!window.customElements.get('activity-product-gallery')) {
  class ActivityProductGallery extends HTMLElement {
    constructor() {
      super();
      this.pendingAddRequests = new Map();
      this.cartObserver = null;
      this.preventBackgroundScroll = this.preventBackgroundScroll.bind(this);
      this.handlePossibleCartClose = this.handlePossibleCartClose.bind(this);
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this.initGallery();
      });
    }

    disconnectedCallback() {
      this.unlockBodyScroll();
    }

    initGallery() {
      const productCards = this.querySelectorAll('li[data-product-id]');
      if (productCards.length === 0) return;

      productCards.forEach((card) => {
        const productId = card.dataset.productId;
        const swatchesContainer = card.querySelector('[data-color-swatches]');
        const textVariantsContainer = card.querySelector('[data-text-variants]');
        const variantJsonScript = card.querySelector(`script[data-variant-json="${productId}"]`);
        const productCardElement = card.querySelector('.product-gallery-card');
        const buyButton = card.querySelector('[data-buy-button]');

        let variantsData = [];
        if (!productCardElement) return;

        if (variantJsonScript) {
          try {
            variantsData = JSON.parse(variantJsonScript.textContent);
            productCardElement.variantsData = variantsData;
          } catch (e) {
            console.error('Error parsing variant data:', e);
            return;
          }
        } else {
          return;
        }

        const initiallyActiveSwatch = swatchesContainer ? swatchesContainer.querySelector('.color-swatch.active') : null;
        let initialVariantId = initiallyActiveSwatch ? initiallyActiveSwatch.dataset.variantId : null;
        let initialVariant = null;

        if (initialVariantId) {
          initialVariant = variantsData.find((v) => v.id == initialVariantId);
        }

        if (!initialVariant || !initialVariant.available) {
          initialVariant = variantsData.find((v) => v.available);
        }

        if (!initialVariant && variantsData.length > 0) {
          initialVariant = variantsData[0];
        }

        if (initialVariant) {
          this.updateCard(productCardElement, initialVariant);

          if (swatchesContainer && (!initiallyActiveSwatch || initiallyActiveSwatch.dataset.variantId != initialVariant.id)) {
            swatchesContainer.querySelectorAll('.color-swatch').forEach((sw) => sw.classList.remove('active'));
            const correctSwatch = swatchesContainer.querySelector(`.color-swatch[data-color-handle="${initialVariant.color_handle}"]`);
            if (correctSwatch) correctSwatch.classList.add('active');
          }

          if (textVariantsContainer) {
            textVariantsContainer.querySelectorAll('.variant-text-btn').forEach((btn) => btn.classList.remove('active'));
            const correctBtn = Array.from(textVariantsContainer.querySelectorAll('.variant-text-btn')).find(
              (btn) => btn.dataset.variantValue === initialVariant.text_option
            );
            if (correctBtn) correctBtn.classList.add('active');
          }
        }

        if (swatchesContainer && variantsData.length > 0) {
          if (!swatchesContainer.hasClickListener) {
            swatchesContainer.addEventListener('click', this.handleSwatchClick.bind(this));
            swatchesContainer.hasClickListener = true;
          }
        }

        if (textVariantsContainer && variantsData.length > 0) {
          if (!textVariantsContainer.hasClickListener) {
            textVariantsContainer.addEventListener('click', this.handleTextVariantClick.bind(this));
            textVariantsContainer.hasClickListener = true;
          }

          this.applyCustomVariantLabels(textVariantsContainer);
          this.updateVariantContainerAlignment(textVariantsContainer);

          if (!textVariantsContainer.hasResizeListener) {
            window.addEventListener('resize', () => {
              this.updateVariantContainerAlignment(textVariantsContainer);
            });
            textVariantsContainer.hasResizeListener = true;
          }
        }

        const addToCartBtns = card.querySelectorAll('[data-add-to-cart]');
        addToCartBtns.forEach((addToCartBtn) => {
          if (addToCartBtn && !addToCartBtn.hasClickListener) {
            addToCartBtn.addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();

              const variantId = addToCartBtn.dataset.selectedVariantId;
              if (variantId) {
                this.addToCart(variantId, addToCartBtn);
              } else {
                this.showToast('Please select an available variant first.', 'error');
              }
            }, true);
            addToCartBtn.hasClickListener = true;
          }

          if (
            addToCartBtn &&
            !addToCartBtn.hasKeyListener &&
            addToCartBtn.getAttribute('role') === 'button'
          ) {
            addToCartBtn.addEventListener('keydown', (e) => {
              if (e.key !== 'Enter' && e.key !== ' ') return;
              e.preventDefault();
              e.stopPropagation();

              const variantId = addToCartBtn.dataset.selectedVariantId;
              if (variantId) {
                this.addToCart(variantId, addToCartBtn);
              } else {
                this.showToast('Please select an available variant first.', 'error');
              }
            }, true);
            addToCartBtn.hasKeyListener = true;
          }
        });

        if (buyButton && !buyButton.hasClickListener) {
          buyButton.addEventListener('click', (e) => {
            e.preventDefault();

            const isAnniversaryActions = buyButton.closest('.product-gallery-card__action-buttons')?.classList.contains('is-anniversary');
            const selectedVariantId = buyButton.dataset.selectedVariantId || null;

            if (isAnniversaryActions) {
              if (selectedVariantId) {
                window.location.href = `${window.Shopify?.routes?.root || '/'}cart/${selectedVariantId}:1?checkout`;
              } else {
                this.showToast('Please select an available variant first.', 'error');
              }
              return;
            }

            const productHandle = buyButton.dataset.productHandle;
            if (productHandle && typeof window.openProductModal === 'function') {
              window.openProductModal(productHandle, selectedVariantId);
            }
          });
          buyButton.hasClickListener = true;
        }
      });
    }

    handleSwatchClick(event) {
      const targetSwatch = event.target.closest('.color-swatch');
      if (!targetSwatch) return;

      const clickedColorHandle = targetSwatch.dataset.colorHandle;
      const swatchesContainer = targetSwatch.closest('[data-color-swatches]');
      const productCardElement = targetSwatch.closest('.product-gallery-card');

      if (!productCardElement || !productCardElement.variantsData || !swatchesContainer) return;

      let selectedVariantData = productCardElement.variantsData.find(
        (v) => v.color_handle === clickedColorHandle && v.available
      );

      if (!selectedVariantData) {
        selectedVariantData = productCardElement.variantsData.find(
          (v) => v.color_handle === clickedColorHandle
        );
      }

      if (selectedVariantData) {
        swatchesContainer.querySelectorAll('.color-swatch').forEach((sw) => sw.classList.remove('active'));
        targetSwatch.classList.add('active');
        this.updateCard(productCardElement, selectedVariantData);
      }
    }

    handleTextVariantClick(event) {
      const targetBtn = event.target.closest('.variant-text-btn');
      if (!targetBtn) return;

      const textVariantsContainer = targetBtn.closest('[data-text-variants]');
      const productCardElement = targetBtn.closest('.product-gallery-card');
      if (!textVariantsContainer || !productCardElement || !productCardElement.variantsData) return;

      const clickedValue = targetBtn.dataset.variantValue;

      let selectedVariantData = productCardElement.variantsData.find(
        (v) => v.text_option === clickedValue && v.available
      );

      if (!selectedVariantData) {
        selectedVariantData = productCardElement.variantsData.find(
          (v) => v.text_option === clickedValue
        );
      }

      if (selectedVariantData) {
        textVariantsContainer.querySelectorAll('.variant-text-btn').forEach((btn) => btn.classList.remove('active'));
        targetBtn.classList.add('active');
        this.updateCard(productCardElement, selectedVariantData);
        this.updateVariantContainerAlignment(textVariantsContainer);
      }
    }

    updateVariantContainerAlignment(container) {
      if (!container) return;

      requestAnimationFrame(() => {
        const isScrollable = container.scrollWidth > container.clientWidth + 1;
        container.classList.toggle('is-scrollable', isScrollable);
      });
    }

    applyCustomVariantLabels(container) {
      if (!container) return;

      const rawMap = (container.dataset.labelMap || '').trim();
      if (!rawMap) return;

      const buttons = Array.from(container.querySelectorAll('.variant-text-btn'));
      if (!buttons.length) return;

      if (!rawMap.includes(':') && rawMap.includes('/')) {
        const labelList = rawMap
          .split('/')
          .map((item) => item.trim())
          .filter(Boolean);

        buttons.forEach((btn, index) => {
          if (labelList[index]) {
            btn.textContent = labelList[index];
          }
        });
        return;
      }

      const mapping = {};
      rawMap.split('\n').forEach((line) => {
        const cleanLine = line.trim();
        if (!cleanLine || !cleanLine.includes(':')) return;

        const parts = cleanLine.split(':');
        const key = parts.shift()?.trim();
        const value = parts.join(':').trim();

        if (key && value) {
          mapping[key.toLowerCase()] = value;
        }
      });

      buttons.forEach((btn) => {
        const rawValue = (btn.dataset.variantValue || '').trim();
        const mappedValue = mapping[rawValue.toLowerCase()];
        if (mappedValue) {
          btn.textContent = mappedValue;
        }
      });
    }

    formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace(/[^\d.]/g, '');
        if (cents.includes('.')) {
          cents = Math.round(parseFloat(cents) * 100);
        } else {
          cents = parseInt(cents, 10);
        }
      }
      if (isNaN(cents)) return '';

      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || window.Shopify?.money_format || '${{amount}}';

      function defaultOption(opt, def) {
        return typeof opt === 'undefined' ? def : opt;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) return '0';
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
        const cents = parts[1] ? decimal + parts[1] : '';
        return dollars + cents;
      }

      let amountType = 'amount';
      const match = formatString.match(placeholderRegex);
      if (match && match[1]) amountType = match[1];

      switch (amountType) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, ',', '.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;
        case 'amount':
        default:
          value = formatWithDelimiters(cents, 2, ',', '.');
          break;
      }

      const replaceRegex = new RegExp(`\\{\\{\\s*${amountType}\\s*\\}\\}`);
      return formatString.replace(replaceRegex, value);
    }

    calculateDiscount(price, compareAtPrice) {
      const numPrice = Number(price);
      const numCompareAtPrice = Number(compareAtPrice);
      if (!isNaN(numCompareAtPrice) && numCompareAtPrice > 0 && !isNaN(numPrice) && numCompareAtPrice > numPrice) {
        const diff = numCompareAtPrice - numPrice;
        return Math.floor((diff * 100) / numCompareAtPrice);
      }
      return 0;
    }

    updateCard(cardElement, selectedVariantData) {
      if (!selectedVariantData || !cardElement) return;

      const priceWrapper = cardElement.querySelector('[data-price-display]');
      if (priceWrapper) {
        const currentPriceFormatted = this.formatMoney(selectedVariantData.price);
        let priceHTML = `<p class="price">${currentPriceFormatted}`;
        if (selectedVariantData.compare_at_price && Number(selectedVariantData.compare_at_price) > Number(selectedVariantData.price)) {
          const comparePriceFormatted = this.formatMoney(selectedVariantData.compare_at_price);
          priceHTML += ` <del>${comparePriceFormatted}</del>`;
        }
        priceHTML += `</p>`;
        if (priceWrapper.innerHTML !== priceHTML) priceWrapper.innerHTML = priceHTML;
      }

      const badgeContainer = cardElement.querySelector('[data-badge-container]');
      if (badgeContainer) {
        const discount = this.calculateDiscount(selectedVariantData.price, selectedVariantData.compare_at_price);
        if (discount > 0) {
          badgeContainer.innerHTML = `-${discount}%`;
          if (!badgeContainer.classList.contains('visible')) badgeContainer.classList.add('visible');
        } else {
          if (badgeContainer.classList.contains('visible')) badgeContainer.classList.remove('visible');
        }
      }

      const buyButton = cardElement.querySelector('[data-buy-button]');
      if (buyButton) {
        buyButton.dataset.selectedVariantId = selectedVariantData.id;
      }

      cardElement.querySelectorAll('[data-add-to-cart]').forEach((addToCartBtn) => {
        addToCartBtn.dataset.selectedVariantId = selectedVariantData.id;
      });
    }

    getToastContainer() {
      return this.querySelector('[data-toast-container]');
    }

    showToast(message, type = 'success') {
      const container = this.getToastContainer();
      if (!container) return;

      const toast = document.createElement('div');
      toast.className = `gallery-toast gallery-toast--${type}`;
      toast.textContent = message;

      container.appendChild(toast);

      requestAnimationFrame(() => {
        toast.classList.add('show');
      });

      setTimeout(() => {
        toast.classList.remove('show');
        setTimeout(() => {
          if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 250);
      }, 3200);
    }

    getEnglishErrorMessage(message) {
      if (!message) {
        return 'An error occurred while adding the product to the cart.';
      }

      const msg = String(message).toLowerCase();

      if (msg.includes('sold out') || msg.includes('ausverkauft')) {
        return 'This product is currently sold out.';
      }

      if (
        msg.includes("can't add more") ||
        msg.includes('cannot add more') ||
        msg.includes('already added the maximum') ||
        msg.includes('all remaining inventory') ||
        msg.includes('nicht mehr hinzufügen')
      ) {
        return 'The maximum available quantity of this product is already in your cart.';
      }

      if (
        msg.includes('insufficient') ||
        msg.includes('not enough') ||
        msg.includes('inventory') ||
        msg.includes('stock') ||
        msg.includes('bestand')
      ) {
        return 'There is not enough inventory available for this product.';
      }

      if (
        msg.includes('invalid') ||
        msg.includes('variant') ||
        msg.includes('unavailable') ||
        msg.includes('nicht verfügbar')
      ) {
        return 'The selected variant is currently unavailable.';
      }

      if (
        msg.includes('network') ||
        msg.includes('fetch')
      ) {
        return 'Network error. Please check your connection and try again.';
      }

      return message;
    }

    setButtonLoading(button, isLoading) {
      if (!button) return;

      const isNativeButton = button.tagName === 'BUTTON';
      const isAnniversaryCartButton = button.classList.contains('anniversary-cart-button');
      const icon = isAnniversaryCartButton ? button.querySelector('.anniversary-cart-badge__icon') : null;

      if (isLoading) {
        button.dataset.loading = 'true';
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');
        if (isNativeButton) button.disabled = true;

        if (isAnniversaryCartButton) {
          if (icon) icon.style.opacity = '0';
          if (!button.querySelector('.cart-loading-spinner')) {
            const spinner = document.createElement('span');
            spinner.className = 'cart-loading-spinner';
            button.appendChild(spinner);
          }
          return;
        }

        if (isNativeButton) {
          if (!button.dataset.originalContent) {
            button.dataset.originalContent = button.innerHTML;
          }
          button.innerHTML = `
            <span>
              <svg width="18" height="18" style="vertical-align: middle; margin-right: 6px;" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" stroke-dasharray="31.4 31.4" stroke-dashoffset="0">
                  <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
                </circle>
              </svg>
              Adding...
            </span>
          `;
        }
      } else {
        button.dataset.loading = 'false';
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
        if (isNativeButton) button.disabled = false;

        if (isAnniversaryCartButton) {
          if (icon) icon.style.opacity = '';
          button.querySelector('.cart-loading-spinner')?.remove();
          return;
        }

        if (isNativeButton && button.dataset.originalContent) {
          button.innerHTML = button.dataset.originalContent;
          delete button.dataset.originalContent;
        }
      }
    }

    dispatchCartEvents(cartData) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartData }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cartData }
      }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart: cartData }
      }));
    }

    async fetchCart() {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('Failed to fetch cart data');
      return response.json();
    }

    async refreshCart() {
      const cartData = await this.fetchCart();
      this.dispatchCartEvents(cartData);

      const miniCart = document.querySelector('cart-drawer, #mini-cart');
      if (miniCart && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(cartData);
      }

      return cartData;
    }

    getCartDrawerElement() {
      return document.querySelector('cart-drawer, #mini-cart, .cart-drawer, .drawer');
    }

    isEventInsideCartDrawer(event) {
      const drawer = this.getCartDrawerElement();
      if (!drawer || !event.target) return false;
      return drawer.contains(event.target);
    }

    preventBackgroundScroll(event) {
      if (this.isEventInsideCartDrawer(event)) return;
      event.preventDefault();
      event.stopPropagation();
    }

    disableGalleryInteraction() {
      this.querySelector('.pc-list-wrapper')?.classList.add('is-cart-open');
    }

    enableGalleryInteraction() {
      this.querySelector('.pc-list-wrapper')?.classList.remove('is-cart-open');
    }

    lockBodyScroll() {
      if (document.body.hasAttribute('data-scroll-locked')) {
        this.disableGalleryInteraction();
        return;
      }

      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

      document.documentElement.classList.add('cart-scroll-locked');
      document.body.classList.add('cart-scroll-locked');
      document.body.dataset.scrollLocked = 'true';
      document.body.dataset.lockedScrollY = String(scrollY);
      document.documentElement.dataset.previousScrollBehavior = document.documentElement.style.scrollBehavior || '';
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;

      this.disableGalleryInteraction();

      window.addEventListener('wheel', this.preventBackgroundScroll, { passive: false, capture: true });
      window.addEventListener('touchmove', this.preventBackgroundScroll, { passive: false, capture: true });
      window.addEventListener('pointermove', this.preventBackgroundScroll, { passive: false, capture: true });
      document.addEventListener('cart:close', this.handlePossibleCartClose, true);
      document.documentElement.addEventListener('cart:close', this.handlePossibleCartClose, true);

      this.observeCartDrawerClose();
    }

    unlockBodyScroll() {
      if (!document.body.hasAttribute('data-scroll-locked')) return;

      const scrollY = Number(document.body.dataset.lockedScrollY || '0');

      window.removeEventListener('wheel', this.preventBackgroundScroll, true);
      window.removeEventListener('touchmove', this.preventBackgroundScroll, true);
      window.removeEventListener('pointermove', this.preventBackgroundScroll, true);
      document.removeEventListener('cart:close', this.handlePossibleCartClose, true);
      document.documentElement.removeEventListener('cart:close', this.handlePossibleCartClose, true);

      if (this.cartObserver) {
        this.cartObserver.disconnect();
        this.cartObserver = null;
      }

      document.documentElement.classList.remove('cart-scroll-locked');
      document.body.classList.remove('cart-scroll-locked');
      document.body.removeAttribute('data-scroll-locked');
      delete document.body.dataset.lockedScrollY;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.documentElement.style.scrollBehavior = 'auto';

      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
        requestAnimationFrame(() => {
          window.scrollTo(0, scrollY);
          document.documentElement.style.scrollBehavior = document.documentElement.dataset.previousScrollBehavior || '';
          delete document.documentElement.dataset.previousScrollBehavior;
        });
      });

      this.enableGalleryInteraction();
    }

    handlePossibleCartClose() {
      requestAnimationFrame(() => this.unlockBodyScroll());
    }

    observeCartDrawerClose() {
      const miniCart = this.getCartDrawerElement();
      if (!miniCart || this.cartObserver) return;

      this.cartObserver = new MutationObserver(() => {
        const isHidden = miniCart.hasAttribute('hidden') ||
          miniCart.getAttribute('aria-hidden') === 'true';

        const isOpen = miniCart.classList.contains('is-open') ||
          miniCart.classList.contains('active') ||
          miniCart.getAttribute('open') !== null ||
          miniCart.getAttribute('aria-hidden') === 'false';

        if (isHidden || !isOpen) {
          this.unlockBodyScroll();
        }
      });

      this.cartObserver.observe(miniCart, {
        attributes: true,
        attributeFilter: ['hidden', 'aria-hidden', 'class', 'open']
      });
    }

    openCartDrawer() {
      const cartToggle = document.querySelector(
        '#lj-menu a[aria-controls="mini-cart"], a[aria-controls="mini-cart"], [data-action="open-drawer"][aria-controls="mini-cart"]'
      );

      if (cartToggle) {
        cartToggle.click();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }

    async addToCart(variantId, button) {
      if (!variantId || !button) return;

      const pendingKey = String(variantId);
      if (button.dataset.loading === 'true' || this.pendingAddRequests.has(pendingKey)) return;

      const requestPromise = this.performAddToCart(variantId, button);
      this.pendingAddRequests.set(pendingKey, requestPromise);

      try {
        await requestPromise;
      } finally {
        this.pendingAddRequests.delete(pendingKey);
      }
    }

    async performAddToCart(variantId, button) {
      this.setButtonLoading(button, true);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        let addResult = {};
        try {
          addResult = await response.json();
        } catch (jsonError) {
          addResult = {};
        }

        if (!response.ok) {
          const serverMessage =
            addResult?.description ||
            addResult?.message ||
            `Failed to add to cart (${response.status})`;
          throw new Error(this.getEnglishErrorMessage(serverMessage));
        }

        await this.refreshCart();
        this.lockBodyScroll();
        this.openCartDrawer();

        setTimeout(() => {
          if (document.body.hasAttribute('data-scroll-locked')) this.disableGalleryInteraction();
        }, 100);
      } catch (error) {
        console.error('Error adding to cart:', error);
        const englishMessage = this.getEnglishErrorMessage(error?.message);
        this.showToast(englishMessage, 'error');
      } finally {
        this.setButtonLoading(button, false);
      }
    }
  }

  window.customElements.define('activity-product-gallery', ActivityProductGallery);
} else {
  document.querySelectorAll('activity-product-gallery').forEach((gallery) => {
    if (typeof gallery.initGallery === 'function') {
      requestAnimationFrame(() => gallery.initGallery());
    }
  });
}

if (typeof window.openProductModal === 'undefined') {
  window.openProductModal = function(productHandle, variantId) {
    console.log(`Trying to open modal: ${productHandle}, variant: ${variantId}`);
  };
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-product-grid"] && !Shopify.designMode) return;
  try {
    
  function activityThrottle(func, delay) {
    let timer = null;
    return function () {
      const context = this;
      const args = arguments;
      if (!timer) {
        timer = setTimeout(() => {
          func.apply(context, args);
          timer = null;
        }, delay);
      }
    };
  }

  class ActivityProductGrid extends HTMLElement {
    constructor() {
      super();
      this.swipers = new Map();
      this.priceWrappers = null;
      this.minDiff = 56;
      this.pendingAddRequests = new Map();
      this.cartObserver = null;
      this.preventBackgroundScroll = this.preventBackgroundScroll.bind(this);
      this.handlePossibleCartClose = this.handlePossibleCartClose.bind(this);
    }

    connectedCallback() {
      const initWhenReady = () => {
        this.init();
        this.handleSizeChange();
        this.equalizeCardHeights();

        this.swipers.forEach((swiperSet) => {
          if (swiperSet.main) swiperSet.main.update();
        });
      };

      if (document.readyState === 'complete') {
        initWhenReady();
      } else {
        window.addEventListener('load', initWhenReady, { once: true });
      }
    }

    disconnectedCallback() {
      this.unlockBodyScroll();
      this.swipers.forEach((swiperSet) => {
        if (swiperSet.main && typeof swiperSet.main.destroy === 'function') {
          swiperSet.main.destroy(true, true);
        }
      });
      this.swipers.clear();
    }

    init() {
      this.querySelectorAll('.product-card').forEach((card) => {
        const blockId = card.dataset.blockId;
        const mainWrapper = card.querySelector('.prompt-swiper .swiper-wrapper');
        if (mainWrapper && mainWrapper.children.length > 0) {
          this.initSwiper(blockId);
        }
      });

      this.priceWrappers = this.querySelectorAll('.price-offers-wrapper');
      this.initEvent();
      this.bindAddToCartButtons();
    }

    initEvent() {
      const handleResize = activityThrottle(() => {
        this.handleSizeChange();
        this.equalizeCardHeights();
      }, 300);

      window.addEventListener('resize', handleResize);

      const images = this.querySelectorAll('img');
      images.forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', () => {
            this.handleSizeChange();
            this.equalizeCardHeights();
          });
        }
      });
    }

    equalizeCardHeights() {
      if (window.innerWidth <= 768) {
        this.querySelectorAll('.product-card').forEach((card) => {
          card.style.height = 'auto';
        });
        return;
      }

      const cards = this.querySelectorAll('.product-card');
      let maxHeight = 840;

      cards.forEach((card) => {
        card.style.height = 'auto';
      });

      cards.forEach((card) => {
        const cardHeight = card.offsetHeight;
        if (cardHeight > maxHeight) {
          maxHeight = cardHeight;
        }
      });

      cards.forEach((card) => {
        card.style.height = `${maxHeight}px`;
      });
    }

    handleSizeChange() {
      if (!this.priceWrappers) return;

      this.priceWrappers.forEach((wrapper) => {
        const wrapperRect = wrapper.getBoundingClientRect();
        const price = wrapper.querySelector('.price');
        const target = wrapper.querySelector('.price-offers');

        if (!price || !target) return;

        const priceRect = price.getBoundingClientRect();
        const diff = wrapperRect.width - priceRect.width;

        if (diff < this.minDiff) {
          const newDiff = this.minDiff - diff;
          const right = -28 + newDiff / 2;
          target.style.right = `${right}px`;
        } else {
          target.style.right = '-28px';
        }
      });
    }

    bindAddToCartButtons() {
      this.querySelectorAll('[data-grid-add-to-cart]').forEach((button) => {
        if (button.dataset.cartBound === 'true') return;
        button.dataset.cartBound = 'true';

        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          const variantId = button.dataset.variantId;
          if (!variantId) return;

          this.addGridProductToCart(variantId, button);
        }, true);
      });
    }

    setButtonLoading(button, isLoading) {
      const icon = button.querySelector('.anniversary-cart-badge__icon');

      if (isLoading) {
        button.dataset.loading = 'true';
        button.classList.add('is-adding');
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('disabled', 'disabled');

        if (icon) {
          icon.style.opacity = '0';
        }

        if (!button.querySelector('.cart-loading-spinner')) {
          const spinner = document.createElement('span');
          spinner.className = 'cart-loading-spinner';
          button.appendChild(spinner);
        }
      } else {
        button.dataset.loading = 'false';
        button.classList.remove('is-adding');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('disabled');

        if (icon) {
          icon.style.opacity = '';
        }

        button.querySelector('.cart-loading-spinner')?.remove();
      }
    }

    dispatchCartEvents(cartData) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartData }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cartData }
      }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart: cartData }
      }));
    }

    async fetchCart() {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });

      if (!response.ok) throw new Error('Failed to fetch cart data');
      return response.json();
    }

    async refreshCart() {
      const cartData = await this.fetchCart();
      this.dispatchCartEvents(cartData);

      const miniCart = document.querySelector('cart-drawer, #mini-cart');
      if (miniCart && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(cartData);
      }

      return cartData;
    }

    getCartDrawerElement() {
      return document.querySelector('cart-drawer, #mini-cart, .cart-drawer, .drawer');
    }

    isEventInsideCartDrawer(event) {
      const drawer = this.getCartDrawerElement();
      if (!drawer || !event.target) return false;
      return drawer.contains(event.target);
    }

    preventBackgroundScroll(event) {
      if (this.isEventInsideCartDrawer(event)) return;
      event.preventDefault();
      event.stopPropagation();
    }

    disableGridInteraction() {
      this.querySelector('.card-list-wrapper')?.classList.add('is-cart-open');
      this.swipers.forEach((swiperSet) => {
        const swiper = swiperSet.main;
        if (!swiper) return;
        swiper.allowTouchMove = false;
        if (swiper.params) {
          swiper.params.allowTouchMove = false;
          swiper.params.simulateTouch = false;
        }
        if (typeof swiper.disable === 'function') swiper.disable();
      });
    }

    enableGridInteraction() {
      this.querySelector('.card-list-wrapper')?.classList.remove('is-cart-open');
      this.swipers.forEach((swiperSet) => {
        const swiper = swiperSet.main;
        if (!swiper) return;
        if (typeof swiper.enable === 'function') swiper.enable();
        swiper.allowTouchMove = true;
        if (swiper.params) {
          swiper.params.allowTouchMove = true;
          swiper.params.simulateTouch = true;
        }
        requestAnimationFrame(() => {
          if (swiper && typeof swiper.update === 'function') swiper.update();
        });
      });
    }

    lockBodyScroll() {
      if (document.body.hasAttribute('data-scroll-locked')) {
        this.disableGridInteraction();
        return;
      }

      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

      document.documentElement.classList.add('cart-scroll-locked');
      document.body.classList.add('cart-scroll-locked');
      document.body.dataset.scrollLocked = 'true';
      document.body.dataset.lockedScrollY = String(scrollY);
      document.documentElement.dataset.previousScrollBehavior = document.documentElement.style.scrollBehavior || '';
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;

      this.disableGridInteraction();

      window.addEventListener('wheel', this.preventBackgroundScroll, { passive: false, capture: true });
      window.addEventListener('touchmove', this.preventBackgroundScroll, { passive: false, capture: true });
      window.addEventListener('pointermove', this.preventBackgroundScroll, { passive: false, capture: true });
      document.addEventListener('cart:close', this.handlePossibleCartClose, true);
      document.documentElement.addEventListener('cart:close', this.handlePossibleCartClose, true);

      this.observeCartDrawerClose();
    }

    unlockBodyScroll() {
      if (!document.body.hasAttribute('data-scroll-locked')) return;

      const scrollY = Number(document.body.dataset.lockedScrollY || '0');

      window.removeEventListener('wheel', this.preventBackgroundScroll, true);
      window.removeEventListener('touchmove', this.preventBackgroundScroll, true);
      window.removeEventListener('pointermove', this.preventBackgroundScroll, true);
      document.removeEventListener('cart:close', this.handlePossibleCartClose, true);
      document.documentElement.removeEventListener('cart:close', this.handlePossibleCartClose, true);

      if (this.cartObserver) {
        this.cartObserver.disconnect();
        this.cartObserver = null;
      }

      document.documentElement.classList.remove('cart-scroll-locked');
      document.body.classList.remove('cart-scroll-locked');
      document.body.removeAttribute('data-scroll-locked');
      delete document.body.dataset.lockedScrollY;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.documentElement.style.scrollBehavior = 'auto';

      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
        requestAnimationFrame(() => {
          window.scrollTo(0, scrollY);
          document.documentElement.style.scrollBehavior = document.documentElement.dataset.previousScrollBehavior || '';
          delete document.documentElement.dataset.previousScrollBehavior;
        });
      });

      this.enableGridInteraction();
    }

    handlePossibleCartClose() {
      requestAnimationFrame(() => this.unlockBodyScroll());
    }

    observeCartDrawerClose() {
      const miniCart = this.getCartDrawerElement();
      if (!miniCart || this.cartObserver) return;

      this.cartObserver = new MutationObserver(() => {
        const isHidden = miniCart.hasAttribute('hidden') ||
          miniCart.getAttribute('aria-hidden') === 'true';

        const isOpen = miniCart.classList.contains('is-open') ||
          miniCart.classList.contains('active') ||
          miniCart.getAttribute('open') !== null ||
          miniCart.getAttribute('aria-hidden') === 'false';

        if (isHidden || !isOpen) {
          this.unlockBodyScroll();
        }
      });

      this.cartObserver.observe(miniCart, {
        attributes: true,
        attributeFilter: ['hidden', 'aria-hidden', 'class', 'open']
      });
    }

    openCartDrawer() {
      const cartToggle = document.querySelector(
        '#lj-menu a[aria-controls="mini-cart"], a[aria-controls="mini-cart"], [data-action="open-drawer"][aria-controls="mini-cart"]'
      );

      if (cartToggle) {
        cartToggle.click();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }

    async addGridProductToCart(variantId, button) {
      if (!variantId || !button) return;

      const pendingKey = String(variantId);
      if (button.dataset.loading === 'true' || this.pendingAddRequests.has(pendingKey)) return;

      const requestPromise = this.performAddToCart(variantId, button);
      this.pendingAddRequests.set(pendingKey, requestPromise);

      try {
        await requestPromise;
      } finally {
        this.pendingAddRequests.delete(pendingKey);
      }
    }

    async performAddToCart(variantId, button) {
      this.setButtonLoading(button, true);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        let addResult = {};
        try {
          addResult = await response.json();
        } catch (jsonError) {
          addResult = {};
        }

        if (!response.ok) {
          const errorMessage = addResult?.description || addResult?.message || `Failed to add to cart (${response.status})`;
          throw new Error(errorMessage);
        }

        await this.refreshCart();
        this.lockBodyScroll();
        this.openCartDrawer();

        setTimeout(() => {
          if (document.body.hasAttribute('data-scroll-locked')) this.disableGridInteraction();
        }, 100);
      } catch (error) {
        console.error('加购失败:', error);
        const message = String(error?.message || 'Failed to add product to cart. Please try again.');
        const friendlyMessage = /sold out|available|inventory|already|maximum|quantity/i.test(message)
          ? 'This item may already be at the maximum available quantity in your cart.'
          : message;
        window.alert(friendlyMessage);
      } finally {
        this.setButtonLoading(button, false);
      }
    }

    initSwiper(blockId) {
      const mainSwiper = new Swiper(`.prompt-swiper-${blockId}`, {
        spaceBetween: 10,
        loop: false,
        slidesPerView: 1,
        navigation: {
          nextEl: `.prompt-swiper-${blockId} .swiper-button-next`,
          prevEl: `.prompt-swiper-${blockId} .swiper-button-prev`,
        }
      });

      this.swipers.set(blockId, {
        main: mainSwiper
      });
    }
  }

  if (!customElements.get('activity-product-grid')) {
    customElements.define('activity-product-grid', ActivityProductGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-product-swiper"] && !Shopify.designMode) return;
  try {
    
  class ActivityProductSwiper extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.boundBadges = new WeakSet();
      this.pendingAddRequests = new Map();
      this.scrollUnlock = null;
      this.cartObserver = null;
      this.preventBackgroundScroll = this.preventBackgroundScroll.bind(this);
      this.handlePossibleCartClose = this.handlePossibleCartClose.bind(this);
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        if (typeof Swiper === 'undefined') {
          console.error('Swiper library is not loaded.');
          return;
        }
        this.initSwiper();
      });
    }

    disconnectedCallback() {
      this.unlockBodyScroll();
      if (this.swiper) {
        try {
          this.swiper.destroy(true, true);
        } catch (e) {
          console.error('Error destroying Swiper:', e);
        }
        this.swiper = null;
      }
    }

    bindAnniversaryCartBadges() {
      const badges = this.querySelectorAll('[data-anniversary-cart-badge]');

      badges.forEach((badge) => {
        if (this.boundBadges.has(badge)) return;
        this.boundBadges.add(badge);
        badge.dataset.cartBound = 'true';

        const handleAdd = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
          }

          const button = badge.closest('[data-anniversary-buy-now]');
          const variantId = button?.dataset.variantId;
          if (!button || !variantId) return;

          this.addAnniversaryProductToCart(variantId, button);
        };

        badge.addEventListener('click', handleAdd, true);
        badge.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            handleAdd(event);
          }
        });
      });
    }

    setAnniversaryButtonLoading(button, isLoading) {
      if (!button) return;

      const icon = button.querySelector('.anniversary-cart-badge__icon');

      if (isLoading) {
        button.dataset.loading = 'true';
        button.classList.add('is-loading');
        button.setAttribute('aria-disabled', 'true');
        if (button.tagName === 'BUTTON') button.disabled = true;

        if (icon) {
          icon.style.opacity = '0';
        }

        if (!button.querySelector('.anniversary-cart-loading-spinner')) {
          const spinner = document.createElement('span');
          spinner.className = 'anniversary-cart-loading-spinner';
          button.appendChild(spinner);
        }
      } else {
        button.dataset.loading = 'false';
        button.classList.remove('is-loading');
        button.removeAttribute('aria-disabled');
        if (button.tagName === 'BUTTON') button.disabled = false;

        if (icon) {
          icon.style.opacity = '';
        }

        button.querySelector('.anniversary-cart-loading-spinner')?.remove();
      }
    }

    dispatchCartEvents(cartData) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartData }
      }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cartData }
      }));
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { cart: cartData }
      }));
    }

    async fetchCart() {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error('Failed to fetch cart data');
      }

      return response.json();
    }

    async refreshCart() {
      try {
        const cartData = await this.fetchCart();
        this.dispatchCartEvents(cartData);

        const miniCart = document.querySelector('cart-drawer, #mini-cart');
        if (miniCart && typeof miniCart.renderContents === 'function') {
          miniCart.renderContents(cartData);
        }

        return cartData;
      } catch (error) {
        console.error('刷新购物车失败:', error);
        return null;
      }
    }

    getCartDrawerElement() {
      return document.querySelector('cart-drawer, #mini-cart, .cart-drawer, .drawer');
    }

    isEventInsideCartDrawer(event) {
      const drawer = this.getCartDrawerElement();
      if (!drawer || !event.target) return false;
      return drawer.contains(event.target);
    }

    preventBackgroundScroll(event) {
      if (this.isEventInsideCartDrawer(event)) return;
      event.preventDefault();
      event.stopPropagation();
    }

    disableSwiperInteraction() {
      const swiperContainer = this.querySelector('.product-swiper');
      if (this.swiper) {
        this.swiper.allowTouchMove = false;
        this.swiper.params.allowTouchMove = false;
        this.swiper.params.simulateTouch = false;
        this.swiper.disable();
      }
      if (swiperContainer) {
        swiperContainer.dataset.swiperDisabled = 'true';
        swiperContainer.style.pointerEvents = 'none';
        swiperContainer.style.userSelect = 'none';
      }
    }

    enableSwiperInteraction() {
      const swiperContainer = this.querySelector('.product-swiper');
      if (this.swiper) {
        this.swiper.enable();
        this.swiper.allowTouchMove = true;
        this.swiper.params.allowTouchMove = true;
        this.swiper.params.simulateTouch = true;
        requestAnimationFrame(() => {
          if (this.swiper && this.swiper.update) this.swiper.update();
        });
      }
      if (swiperContainer) {
        delete swiperContainer.dataset.swiperDisabled;
        swiperContainer.style.pointerEvents = '';
        swiperContainer.style.userSelect = '';
      }
    }

    lockBodyScroll() {
      if (document.body.hasAttribute('data-scroll-locked')) {
        this.disableSwiperInteraction();
        return;
      }

      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

      document.documentElement.classList.add('cart-scroll-locked');
      document.body.classList.add('cart-scroll-locked');
      document.body.dataset.scrollLocked = 'true';
      document.body.dataset.lockedScrollY = String(scrollY);
      document.documentElement.dataset.previousScrollBehavior = document.documentElement.style.scrollBehavior || '';
      document.documentElement.style.scrollBehavior = 'auto';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;

      this.disableSwiperInteraction();

      window.addEventListener('wheel', this.preventBackgroundScroll, { passive: false, capture: true });
      window.addEventListener('touchmove', this.preventBackgroundScroll, { passive: false, capture: true });
      window.addEventListener('pointermove', this.preventBackgroundScroll, { passive: false, capture: true });
      document.addEventListener('cart:close', this.handlePossibleCartClose, true);
      document.documentElement.addEventListener('cart:close', this.handlePossibleCartClose, true);

      this.observeCartDrawerClose();
    }

    unlockBodyScroll() {
      if (!document.body.hasAttribute('data-scroll-locked')) return;

      const scrollY = Number(document.body.dataset.lockedScrollY || '0');

      window.removeEventListener('wheel', this.preventBackgroundScroll, true);
      window.removeEventListener('touchmove', this.preventBackgroundScroll, true);
      window.removeEventListener('pointermove', this.preventBackgroundScroll, true);
      document.removeEventListener('cart:close', this.handlePossibleCartClose, true);
      document.documentElement.removeEventListener('cart:close', this.handlePossibleCartClose, true);

      if (this.cartObserver) {
        this.cartObserver.disconnect();
        this.cartObserver = null;
      }

      document.documentElement.classList.remove('cart-scroll-locked');
      document.body.classList.remove('cart-scroll-locked');
      document.body.removeAttribute('data-scroll-locked');
      delete document.body.dataset.lockedScrollY;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.documentElement.style.scrollBehavior = 'auto';

      requestAnimationFrame(() => {
        window.scrollTo(0, scrollY);
        requestAnimationFrame(() => {
          window.scrollTo(0, scrollY);
          document.documentElement.style.scrollBehavior = document.documentElement.dataset.previousScrollBehavior || '';
          delete document.documentElement.dataset.previousScrollBehavior;
        });
      });

      this.enableSwiperInteraction();
    }

    handlePossibleCartClose() {
      requestAnimationFrame(() => this.unlockBodyScroll());
    }

    observeCartDrawerClose() {
      const miniCart = this.getCartDrawerElement();
      if (!miniCart || this.cartObserver) return;

      this.cartObserver = new MutationObserver(() => {
        const isHidden = miniCart.hasAttribute('hidden') ||
          miniCart.getAttribute('aria-hidden') === 'true' ||
          miniCart.classList.contains('is-empty') && !miniCart.classList.contains('is-open');

        const isOpen = miniCart.classList.contains('is-open') ||
          miniCart.classList.contains('active') ||
          miniCart.getAttribute('open') !== null ||
          miniCart.getAttribute('aria-hidden') === 'false';

        if (isHidden || !isOpen) {
          this.unlockBodyScroll();
        }
      });

      this.cartObserver.observe(miniCart, {
        attributes: true,
        attributeFilter: ['hidden', 'aria-hidden', 'class', 'open']
      });
    }

    openCartDrawer() {
      const cartToggle = document.querySelector(
        '#lj-menu a[aria-controls="mini-cart"], a[aria-controls="mini-cart"], [data-action="open-drawer"][aria-controls="mini-cart"]'
      );

      if (cartToggle) {
        cartToggle.click();
        return;
      }

      document.documentElement.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }

    async addAnniversaryProductToCart(variantId, button) {
      if (!variantId || !button) return;

      const pendingKey = String(variantId);
      if (button.dataset.loading === 'true' || this.pendingAddRequests.has(pendingKey)) {
        return;
      }

      const requestPromise = this.performAddToCart(variantId, button);
      this.pendingAddRequests.set(pendingKey, requestPromise);

      try {
        await requestPromise;
      } finally {
        this.pendingAddRequests.delete(pendingKey);
      }
    }

    async performAddToCart(variantId, button) {
      this.setAnniversaryButtonLoading(button, true);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        let addResult = {};
        try {
          addResult = await response.json();
        } catch (jsonError) {
          addResult = {};
        }

        if (!response.ok) {
          const errorMessage = addResult?.description || addResult?.message || `Failed to add to cart (${response.status})`;
          throw new Error(errorMessage);
        }

        const cartData = await this.refreshCart();
        this.lockBodyScroll();
        this.openCartDrawer();

        setTimeout(() => {
          if (document.body.hasAttribute('data-scroll-locked')) {
            this.disableSwiperInteraction();
          }
        }, 100);

        return cartData;
      } catch (error) {
        console.error('加购失败:', error);
        await this.refreshCart();

        const message = String(error?.message || 'Failed to add product to cart. Please try again.');
        const friendlyMessage = /sold out|available|inventory|already|maximum|quantity/i.test(message)
          ? 'This item may already be at the maximum available quantity in your cart.'
          : message;
        window.alert(friendlyMessage);
      } finally {
        this.setAnniversaryButtonLoading(button, false);
      }
    }

    initSwiper() {
      const swiperContainer = this.querySelector('.product-swiper');

      if (!swiperContainer) {
        console.error('Swiper container (.product-swiper) not found within <activity-product-swiper>.');
        return;
      }

      const slides = swiperContainer.querySelectorAll('.swiper-slide');
      if (slides.length === 0) {
        const navPrev = swiperContainer.querySelector('.swiper-button-prev');
        const navNext = swiperContainer.querySelector('.swiper-button-next');
        const pagination = swiperContainer.querySelector('.swiper-pagination');
        if (navPrev) navPrev.style.display = 'none';
        if (navNext) navNext.style.display = 'none';
        if (pagination) pagination.style.display = 'none';
        return;
      }

      const nextButton = swiperContainer.querySelector('.swiper-button-next');
      const prevButton = swiperContainer.querySelector('.swiper-button-prev');
      const paginationEl = swiperContainer.querySelector('.swiper-pagination');

      if (this.swiper) {
        this.swiper.destroy(true, true);
      }

      this.swiper = new Swiper(swiperContainer, {
        loop: false,
        autoplay: false,
        spaceBetween: 50,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        watchOverflow: true,
        grabCursor: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        centeredSlides: false,
        slidesOffsetBefore: 0,
        slidesOffsetAfter: 0,
        allowTouchMove: true,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        preventClicks: true,
        preventClicksPropagation: true,
      });

      this.bindAnniversaryCartBadges();
    }
  }

  if (!window.customElements.get('activity-product-swiper')) {
    window.customElements.define('activity-product-swiper', ActivityProductSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity-scene-list"] && !Shopify.designMode) return;
  try {
    
  class PromptSceneListWithHotspots extends HTMLElement {
    constructor() {
      super();
      const rawBlocksData = this.dataset.blocks || '[]';
      console.log(this.dataset.blocks)
      const rawProductsData = this.dataset.products || '{}';

      try {
        this.blocksData = JSON.parse(rawBlocksData);
      } catch (e) {
        console.error('解析 Block 数据失败:', e, rawBlocksData);
        this.blocksData = [];
      }
      try {
        this.productsData = JSON.parse(rawProductsData.trim());
      } catch (e) {
        console.error('解析 Product 数据失败:', e, rawProductsData);
        this.productsData = {};
      }

      this.sceneImages = Array.from(this.querySelectorAll('.scene-image'));
      this.hotspotContainer = this.querySelector('#hotspots-container');
      this.tooltipTemplate = this.querySelector('#product-tooltip-template');
      this.activeTooltip = null;
      this.activeBlockId = null;
      this.hideTimeoutId = null;

      this.mobileProductDisplay = this.querySelector('#mobile-product-display');
      this.mobileProductImage = this.querySelector('.mobile-product__image');
      this.mobileProductTitleText = this.querySelector('.mobile-product__title-text');
      this.mobileProductPrice = this.querySelector('.mobile-product__price');
      this.mobileProductNewBadge = this.querySelector('#mobile-product-display .new-badge');

      this.isMobile = window.innerWidth <= 768;
      this.handleResize = this._handleResize.bind(this);
    }

    connectedCallback() {
      if (
        !this.sceneImages.length ||
        !this.hotspotContainer ||
        !this.tooltipTemplate ||
        !this.mobileProductDisplay ||
        !this.mobileProductImage ||
        !this.mobileProductTitleText ||
        !this.mobileProductPrice
      ) {
        console.error('PromptSceneList 初始化失败: 缺少必要的 DOM 元素');
        return;
      }

      this.initButtonEvent();
      window.addEventListener('resize', this.handleResize);
      // 添加移动端价格点击事件
      if (this.mobileProductPrice) {
        this.mobileProductPrice.addEventListener('click', () => {
          if (this.activeBlockId) {
            const block = this.blocksData.find((b) => b.id?.toString() === this.activeBlockId);
            if (block && block.settings.product_handle) {
              if (typeof window.openProductModal === 'function') {
                window.openProductModal(block.settings.product_handle,"",this.dataset.producttype);
              }
            }
          }
        });
      }

      // 预加载所有图片后激活第一个block
      this._preloadImages().then(() => {
        this._updateLayout(true);
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    async _preloadImages() {
      const preloadPromises = this.sceneImages.map((img) => {
        return new Promise((resolve) => {
          if (img.complete) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve; // 即使加载失败也继续
          }
        });
      });

      await Promise.all(preloadPromises);
      console.log('所有图片预加载完成');
    }

    _handleResize() {
      const newIsMobile = window.innerWidth <= 768;
      if (newIsMobile !== this.isMobile) {
        this.isMobile = newIsMobile;
        this._updateLayout(false);
      }
    }

    _updateLayout(activateFirst = false) {
      if (this.isMobile) {
        if (this.activeTooltip) this.hideTooltip();
        this.clearHotspots();
      } else {
        if (this.mobileProductDisplay) this.mobileProductDisplay.style.display = 'none';
      }

      const blockToActivate = activateFirst ? this.blocksData[0]?.id ?? null : this.activeBlockId;

      if (blockToActivate) {
        this.activateBlock(blockToActivate);
      } else if (activateFirst) {
        console.warn('没有找到可激活的 Block');
        this.updateMobileProductDisplay(null);
      }
    }

    initButtonEvent() {
      const buttons = this.querySelectorAll('.button-wrapper button.switch');
      buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          const clickedButton = event.currentTarget;
          const blockId = clickedButton.dataset.blockId;
          if (blockId === this.activeBlockId) return;

          this.clearActiveStatus();
          clickedButton.classList.add('active');
          this.activateBlock(blockId);

          if (this.isMobile && typeof clickedButton.scrollIntoView === 'function') {
            clickedButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
          }
        });
      });
    }

    clearActiveStatus() {
      this.querySelectorAll('.button-wrapper button.switch').forEach((btn) => {
        btn.classList.remove('active');
      });
    }
    openProductModalFromDisplay() {
      if (!this.activeBlockId) return;

      const block = this.blocksData.find((b) => b.id?.toString() === this.activeBlockId);
      if (block && block.settings.product_handle) {
        this.hideTooltip(true); 
        openProductModal(block.settings.product_handle);
      }
    }
    activateBlock(blockId) {
      const targetBlockId = blockId?.toString();
      if (!targetBlockId) {
        console.warn('没有提供 block ID 进行激活');
        this.clearHotspots();
        this.updateMobileProductDisplay(null);
        return;
      }

      const block = this.blocksData.find((b) => b.id?.toString() === targetBlockId);
      if (!block || !block.settings) {
        console.warn(`未找到 ID 为 ${targetBlockId} 的 Block 数据`);
        this.clearActiveStatus();
        this.activeBlockId = null;
        this.clearHotspots();
        this.updateMobileProductDisplay(null);
        return;
      }

      this.activeBlockId = targetBlockId;
      console.log(`激活 Block ID: ${this.activeBlockId}, 是否移动端: ${this.isMobile}`);

      // 更新图片显示状态
      this.sceneImages.forEach((img) => {
        img.classList.remove('active');
        if (img.dataset.blockId === targetBlockId) {
          img.classList.add('active');
        }
      });

      // 更新热点或移动端显示
      if (this.isMobile) {
        this.updateMobileProductDisplay(block.settings.product_handle);
        this.clearHotspots();
        if (this.mobileProductDisplay) this.mobileProductDisplay.style.display = 'flex';
      } else {
        this.updateHotspot(block.settings, targetBlockId);
        if (this.mobileProductDisplay) this.mobileProductDisplay.style.display = 'none';
      }
    }

    updateHotspot(blockSettings, blockId) {
      if (this.isMobile) {
        this.clearHotspots();
        return;
      }

      this.clearHotspots();

      const productHandle = blockSettings?.product_handle;
      if (!productHandle || typeof productHandle !== 'string' || productHandle.trim() === '') {
        return;
      }
      if (!this.productsData[productHandle]) {
        console.warn(`找不到产品数据: ${productHandle}`);
        return;
      }
      const hasPosition = blockSettings?.hotspot_x != null && blockSettings?.hotspot_y != null;
      const productDataExists = productHandle && this.productsData[productHandle];

      if (hasPosition && productHandle && productHandle.trim() !== '' && productDataExists) {
        const hotspot = document.createElement('div');
        hotspot.className = 'hotspot';
        hotspot.style.left = `${blockSettings.hotspot_x}%`;
        hotspot.style.top = `${blockSettings.hotspot_y}%`;
        hotspot.dataset.productHandle = productHandle;
        hotspot.dataset.blockId = blockId;

        hotspot.addEventListener('mouseenter', (e) => {
          clearTimeout(this.hideTimeoutId);
          this.showTooltip(e.currentTarget);
        });
        hotspot.addEventListener('mouseleave', () => {
          this.hideTimeoutId = setTimeout(() => {
            this.hideTooltip();
          }, 200);
        });

        if (this.hotspotContainer) {
          this.hotspotContainer.appendChild(hotspot);
        }
      }
    }

    clearHotspots() {
      if (this.hotspotContainer) {
        this.hotspotContainer.innerHTML = '';
      }
      this.hideTooltip();
    }

    updateMobileProductDisplay(productHandle) {
      if (
        !this.mobileProductDisplay ||
        !this.mobileProductImage ||
        !this.mobileProductTitleText ||
        !this.mobileProductPrice ||
        !this.mobileProductNewBadge
      ) {
        if (this.mobileProductDisplay) this.mobileProductDisplay.style.display = 'none';
        return;
      }
      const handle = typeof productHandle === 'string' ? productHandle.trim() : '';
      const productData = handle && this.productsData[handle] ? this.productsData[handle] : null;

      if (productData) {
        this.mobileProductImage.src = productData.featured_image?.src || '';
        this.mobileProductImage.alt = productData.featured_image?.alt || productData.title || '产品图片';
        this.mobileProductTitleText.textContent = productData.title;
        const price = productData.price || '$0.00';
        this.mobileProductPrice.innerHTML = `${price}<span>></span>`;
        this.mobileProductNewBadge.style.display = 'inline-block';
        this.mobileProductDisplay.style.display = 'flex';
      } else {
        this.mobileProductDisplay.style.display = 'none';
      }
    }

    showTooltip(hotspotElement) {
      if (this.isMobile) {
        return;
      }

      const productHandle = hotspotElement?.dataset?.productHandle;
      if (!hotspotElement || !productHandle || !this.tooltipTemplate || !this.productsData[productHandle]) {
        this.hideTooltip();
        return;
      }

      const productData = this.productsData[productHandle];

      if (this.activeTooltip) {
        this.hideTooltip();
      }

      const tooltipClone = this.tooltipTemplate.content.cloneNode(true);
      const tooltip = tooltipClone.querySelector('.product-tooltip');
      if (!tooltip) {
        return;
      }
      this.appendChild(tooltip);

      const imgEl = tooltip.querySelector('.product-tooltip__image');
      const titleSpan = tooltip.querySelector('.product-tooltip__title span:last-child');
      const priceEl = tooltip.querySelector('.product-tooltip__price');
      const newBadgeEl = tooltip.querySelector('.new-badge');

      if (imgEl) {
        imgEl.src = productData.featured_image?.src || '';
        imgEl.alt = productData.featured_image?.alt || productData.title || '';
      }
      if (titleSpan) titleSpan.textContent = productData.title;
      let priceHTML = `${productData.price}<span>></span>`;
      if (priceEl) priceEl.innerHTML = priceHTML;
      if (newBadgeEl) {
        newBadgeEl.style.display = 'inline-block';
      }

      if (priceEl) {
        priceEl.style.cursor = 'pointer';
        priceEl.addEventListener('click', (event) => {
          event.preventDefault(); 
          const handleToOpen = productHandle; 
          this.hideTooltip(true); 
          setTimeout(() => {
            if (typeof window.openProductModal === 'function') {
              window.openProductModal(handleToOpen,"",this.dataset.producttype);
            } else {
              console.error('window.openProductModal 函数未找到!');
            }
          }, 1000);
        });
      }

      const hotspotRect = hotspotElement.getBoundingClientRect();
      const containerRect = this.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      const tooltipWidth = tooltip.offsetWidth || 280;
      const tooltipHeight = tooltip.offsetHeight || 120;
      const offset = 10;

      let top = hotspotRect.bottom + window.scrollY + offset;
      let left = hotspotRect.left + window.scrollX + hotspotRect.width / 2 - tooltipWidth / 2;

      if (top + tooltipHeight > viewportHeight + window.scrollY - offset) {
        top = hotspotRect.top + window.scrollY - tooltipHeight - offset;
      }
      top = Math.max(window.scrollY + offset, top);

      left = Math.max(window.scrollX + offset, left);
      left = Math.min(window.scrollX + viewportWidth - tooltipWidth - offset, left);

      tooltip.style.position = 'absolute';
      tooltip.style.top = `${top}px`;
      tooltip.style.left = `${left}px`;

      tooltip.dataset.productHandle = productHandle;
      tooltip.addEventListener('mouseenter', () => {
        clearTimeout(this.hideTimeoutId);
      });
      tooltip.addEventListener('mouseleave', () => {
        this.hideTimeoutId = setTimeout(() => {
          this.hideTooltip();
        }, 200);
      });

      this.activeTooltip = tooltip;
      requestAnimationFrame(() => {
        tooltip.classList.add('visible');
      });
    }

    hideTooltip() {
      if (this.activeTooltip) {
        const currentTooltip = this.activeTooltip;
        this.activeTooltip = null;

        currentTooltip.classList.remove('visible');

        const removeTooltip = () => {
          if (currentTooltip && currentTooltip.parentNode === this) {
            currentTooltip.remove();
          }
        };

        currentTooltip.addEventListener('transitionend', removeTooltip, { once: true });
        setTimeout(removeTooltip, 350);
      }
    }
  }

  if (!customElements.get('activity-scene-list')) {
    customElements.define('activity-scene-list', PromptSceneListWithHotspots);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portable-header"] && !Shopify.designMode) return;
  try {
    
  var PromptHeader = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {}
  };
  if (!window.customElements.get('prompt-header')) {
    window.customElements.define('prompt-header', PromptHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portable-product-card"] && !Shopify.designMode) return;
  try {
    
  function ljThrottle(func, delay) {
    let timer = null;
    return function () {
      const context = this;
      const args = arguments;
      if (!timer) {
        timer = setTimeout(() => {
          func.apply(context, args);
          timer = null;
        }, delay);
      }
    };
  }
  class PromptProductCard extends HTMLElement {
    constructor() {
      super();
      this.swipers = new Map();
      this.priceWrappers = null;
      this.minDiff = 56;
      document.addEventListener('DOMContentLoaded', () => {
        this.handleSizeChange();
      });
    }

    connectedCallback() {
      window.addEventListener('load', () => {
        this.init(); // 调用初始化 Swiper 的方法
        this.handleSizeChange(); // 确保其他依赖尺寸的逻辑也更新

        // 遍历所有 Swiper 实例并强制更新其布局
        this.swipers.forEach((swiperSet) => {
          if (swiperSet.main) {
            console.log(`--- Swiper ${swiperSet.main.el.className} Before Update ---`);
            console.log('Swiper params.width:', swiperSet.main.params.width);
            console.log('Swiper width:', swiperSet.main.width);
            swiperSet.main.slides.forEach((slide, index) => {
              console.log(`Slide ${index} clientWidth:`, slide.clientWidth);
              console.log(`Slide ${index} offsetWidth:`, slide.offsetWidth);
              const img = slide.querySelector('img');
              if (img) {
                console.log(`Image ${index} naturalWidth:`, img.naturalWidth);
                console.log(`Image ${index} naturalHeight:`, img.naturalHeight);
                console.log(`Image ${index} clientWidth:`, img.clientWidth);
                console.log(`Image ${index} offsetWidth:`, img.offsetWidth);
              }
            });
            console.log(`--- Swiper ${swiperSet.main.el.className} After Update ---`);
            swiperSet.main.update();
            console.log('Swiper width after update:', swiperSet.main.width);
            // 再次检查幻灯片宽度
            swiperSet.main.slides.forEach((slide, index) => {
              console.log(`Slide ${index} clientWidth after update:`, slide.clientWidth);
            });
          }
        });
      });
    }

    init() {
      this.querySelectorAll('.product-card').forEach((card) => {
        const blockId = card.dataset.blockId;
        if (card.querySelector('.swiper-wrapper').children.length > 0) {
          this.initSwiper(blockId);
        }
      });
      this.initEvent();
      this.priceWrappers = document.querySelectorAll('.price-offers-wrapper');
    }
    handleSizeChange() {
      if (!this.priceWrappers) return;
      this.priceWrappers.forEach((wrapper) => {
        const wrapperRect = wrapper.getBoundingClientRect();
        const price = wrapper.querySelector('.price');
        const priceRect = price.getBoundingClientRect();
        const diff = wrapperRect.width - priceRect.width;
        const target = wrapper.querySelector('.price-offers');
        if (diff < this.minDiff) {
          const newDiff = this.minDiff - diff;
          const right = -28 + newDiff / 2;
          target.style.right = `${right}px`;
        } else {
          target.style.right = `-28px`;
        }
      });
    }
    initEvent() {
      const handleSizeChange = ljThrottle(this.handleSizeChange.bind(this), 500);
      window.addEventListener('resize', handleSizeChange);
    }

    initSwiper(blockId) {
      const thumbsSwiper = new Swiper(`.thumb-swiper-${blockId}`, {
        direction: this.dataset.thumb_position === 'left' ? 'vertical' : 'horizontal',
        spaceBetween: 5,
        slidesPerView: 4,
        watchSlidesVisibility: true,
        freeMode: true,
        watchSlidesProgress: true,
      });

      const mainSwiper = new Swiper(`.prompt-swiper-${blockId}`, {
        spaceBetween: 10,
        loop: false,
        slidesPerView: 'auto',
        navigation: {
          nextEl: `.prompt-swiper-${blockId} .swiper-button-next`,
          prevEl: `.prompt-swiper-${blockId} .swiper-button-prev`,
        },
        pagination: {
          el: `.prompt-swiper-${blockId} .swiper-pagination`,
          clickable: true,
        },
        thumbs: {
          swiper: thumbsSwiper,
          autoScrollOffset: 1,
        },
      });

      this.swipers.set(blockId, {
        main: mainSwiper,
        thumbs: thumbsSwiper,
      });
    }
  }
  customElements.define('portable-product-card', PromptProductCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-faq-bf"] && !Shopify.designMode) return;
  try {
    
  class PromptFAQ extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initEvent();
    }

    initEvent() {
      const faqList = this.querySelector('.faq-list')
      if (! faqList) return


      


      faqList.addEventListener('click', (event) => {
        const currentRow = event.target.closest('.row')

// 如果点击的不是row或其子元素，直接返回
        if (! currentRow) return


        


// 关闭其他所有展开的行
        const previouslyOpenRow = faqList
        .querySelector('.row.active')
          if (previouslyOpenRow && previouslyOpenRow !== currentRow) {
            previouslyOpenRow
              .classList
              .remove('active')
              previouslyOpenRow
              .querySelector('.answer')
              .classList
              .remove('show')

  // 显示加号，隐藏减号
            previouslyOpenRow
            .querySelectorAll('.icon-right')
            .forEach(icon => {
              icon.classList.toggle('hide', !icon.classList.contains('hide'))
            })
        }

  // 切换当前行的状态
        currentRow
        .classList
        .toggle('active')
        currentRow
        .querySelector('.answer')
        .classList
        .toggle('show')

// 切换加号和减号的显示状态
      currentRow
      .querySelectorAll('.icon-right')
      .forEach(icon => {
        icon.classList.toggle('hide')
      })
  })
}}if (!window.customElements.get('prompt-faq')) {
customElements.define('prompt-faq', PromptFAQ);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-faq"] && !Shopify.designMode) return;
  try {
    
  class PromptFAQ extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initEvent();
    }

    initEvent() {
      const faqList = this.querySelector('.faq-list')
      if (! faqList) return


      


      faqList.addEventListener('click', (event) => {
        const currentRow = event.target.closest('.row')

// 如果点击的不是row或其子元素，直接返回
        if (! currentRow) return


        


// 关闭其他所有展开的行
        const previouslyOpenRow = faqList
        .querySelector('.row.active')
          if (previouslyOpenRow && previouslyOpenRow !== currentRow) {
            previouslyOpenRow
              .classList
              .remove('active')
              previouslyOpenRow
              .querySelector('.answer')
              .classList
              .remove('show')

  // 显示加号，隐藏减号
            previouslyOpenRow
            .querySelectorAll('.icon-right')
            .forEach(icon => {
              icon.classList.toggle('hide', !icon.classList.contains('hide'))
            })
        }

  // 切换当前行的状态
        currentRow
        .classList
        .toggle('active')
        currentRow
        .querySelector('.answer')
        .classList
        .toggle('show')

// 切换加号和减号的显示状态
      currentRow
      .querySelectorAll('.icon-right')
      .forEach(icon => {
        icon.classList.toggle('hide')
      })
  })
}}if (!window.customElements.get('prompt-faq')) {
customElements.define('prompt-faq', PromptFAQ);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-header"] && !Shopify.designMode) return;
  try {
    
  var PromptHeader = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {}
  }
  if (!window.customElements.get('prompt-header')) {
    window.customElements.define('prompt-header', PromptHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-main-slide"] && !Shopify.designMode) return;
  try {
    
  var PromptMainSlider = class extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    isMobile() {
      const mediaQuery = '(max-width: 768px)';
      const mql = window.matchMedia(mediaQuery);

      if (mql.matches) {
        return true;
      } else {
        return false;
      }
    }

    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.pc-swiper-' + id;
      let paginationClassname = '.pc-pagination-' + id;
      if (this.isMobile()) {
        className = '.mobile-swiper-' + id;
        paginationClassname = '.mobile-pagination-' + id;
      }
      const speed = this.dataset.speed
      this.swiper = new Swiper(className, {
        loop: true,
        autoplay: {
          delay: speed * 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        spaceBetween: 20,
        slidesPerView: 'auto',
        pagination: {
          el: paginationClassname,
          clickable: true,
        },
        on: {
          slideChangeTransitionEnd: function () {
            // 获取当前激活的slide
            const activeSlide = this.slides[this.activeIndex];
            // 获取按钮文本
            const btnText = activeSlide.getAttribute('data-btntext');
            // 获取对应的button元素并更新内容
            const button = activeSlide.closest('.swiper').querySelector('.prompt-button span');
            if (button && btnText) {
              button.textContent = btnText;
            }
          }
        }
      });
    }

    initBuyButton() {
      const buyButtons = this.querySelectorAll('button.prompt-button');
      const _this = this;
      for(const buyButton of buyButtons){
        buyButton.addEventListener('click', function () {
          const curr = _this.swiper.slides[_this.swiper.activeIndex];
          const link = curr.getAttribute('link');
          window.location.href = link;
        });
      }
    }

    connectedCallback() {
      this.initSwiper();
      this.initBuyButton();
    }
  };
  if (!window.customElements.get('prompt-main-slide')) {
    window.customElements.define('prompt-main-slide', PromptMainSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-picture-swiper"] && !Shopify.designMode) return;
  try {
    
  class PromptPictureSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const selector = `.swiper-${this.dataset.sectionid}`;
      this.swiper = new Swiper(selector, {
        loop: true,
        autoplay: {
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        spaceBetween: 20,
        slidesPerView: 'auto',
      });
    }
  }
  if (!window.customElements.get('prompt-picture-swiper')) {
    window.customElements.define('prompt-picture-swiper', PromptPictureSwiper);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-product-card"] && !Shopify.designMode) return;
  try {
    
  function ljThrottle(func, delay) {
      let timer = null;
      return function() {
          const context = this;
          const args = arguments;
          if (!timer) {
              timer = setTimeout(() => {
                  func.apply(context, args);
                  timer = null;
              }, delay);
          }
      };
  }
  class PromptProductCard extends HTMLElement {
    constructor() {
      super();
      this.swipers = new Map();
      this.priceWrappers = null
      this.minDiff = 56
      document.addEventListener('DOMContentLoaded', () => {
        this.handleSizeChange()
      });
    }

    connectedCallback(){
        this.init();
    }

    init() {
      this.querySelectorAll('.product-card').forEach((card) => {
        const blockId = card.dataset.blockId;
        if (card.querySelector('.swiper-wrapper').children.length > 0) {
          this.initSwiper(blockId);
        }
      });
      this.initEvent()
      this.priceWrappers = document.querySelectorAll('.price-offers-wrapper')
    
    }
    handleSizeChange(){
        if(!this.priceWrappers) return
        this.priceWrappers.forEach((wrapper)=>{
            const wrapperRect = wrapper.getBoundingClientRect()
            const price = wrapper.querySelector('.price')
            const priceRect = price.getBoundingClientRect()
            const diff = wrapperRect.width - priceRect.width
            const target = wrapper.querySelector(".price-offers")
            if(diff < this.minDiff){
                const newDiff = this.minDiff - diff
                const right = -28 + newDiff/2
                target.style.right = `${right}px`
            }else{
                target.style.right = `-28px`
            }
        })
    }
    initEvent(){
        const handleSizeChange = ljThrottle(this.handleSizeChange.bind(this), 500)
        window.addEventListener('resize', handleSizeChange)
    }

    initSwiper(blockId) {
      const thumbsSwiper = new Swiper(`.thumb-swiper-${blockId}`, {
        direction: this.dataset.thumb_position === 'left' ? 'vertical' : 'horizontal',
        spaceBetween: 5,
        slidesPerView: 4,
        watchSlidesVisibility: true,
        freeMode: true,
        watchSlidesProgress: true,
      });

      const mainSwiper = new Swiper(`.prompt-swiper-${blockId}`, {
        spaceBetween: 10,
        loop: false,
        navigation: {
          nextEl: `.prompt-swiper-${blockId} .swiper-button-next`,
          prevEl: `.prompt-swiper-${blockId} .swiper-button-prev`,
        },
        pagination: {
          el: `.prompt-swiper-${blockId} .swiper-pagination`,
          clickable: true,
        },
        thumbs: {
          swiper: thumbsSwiper,
          autoScrollOffset: 1,
        },
      });

      this.swipers.set(blockId, {
        main: mainSwiper,
        thumbs: thumbsSwiper,
      });
    }
  }
  customElements.define('prompt-product-card', PromptProductCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-review-slide"] && !Shopify.designMode) return;
  try {
    
  var PromptReviewList = class extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    isMobile() {
      const mediaQuery = '(max-width: 768px)';
      const mql = window.matchMedia(mediaQuery);

      if (mql.matches) {
        return true;
      } else {
        return false;
      }
    }

    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.pc-swiper-' + id;
      let paginationClassname = '.pagination-' + id;
      this.swiper = new Swiper(className, {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 'auto',
        pagination: {
          el: paginationClassname,
          clickable: true,
        },
        autoplay: {
          delay: 30000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    }

    connectedCallback() {
      this.initSwiper();
    }
  };
  if (!window.customElements.get('prompt-review-slide')) {
    window.customElements.define('prompt-review-slide', PromptReviewList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-simple-product-card"] && !Shopify.designMode) return;
  try {
    
  class PromptSimpleProductCard extends HTMLElement {
    constructor() {
      super();
    }
  }
  customElements.define('prompt-simple-product-card', PromptSimpleProductCard);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-two-pictures"] && !Shopify.designMode) return;
  try {
    
  var PromptTwoPictures = class PromptTwoPictures extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
        this.initSwiper()
    }
    initSwiper() {
      let id = this.getAttribute('section-id');
      let className = '.swiper-' + id;
      this.swiper = new Swiper(className, {
        autoplay: {
          reverseDirection: true,
          waitForTransition: true,
          delay: 1000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        },
        spaceBetween: 20,
        slidesPerView: 'auto',
      });
    }
  };
  if (!window.customElements.get('prompt-two-pictures')) {
    window.customElements.define('prompt-two-pictures', PromptTwoPictures);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prompt-video-list"] && !Shopify.designMode) return;
  try {
    
  // 定义一个函数来检查元素的祖先元素是否 display: none
  function hasHiddenAncestor(element) {
    // 获取元素的父元素
    let parent = element.parentElement;
    // 当父元素存在时进行循环检查
    while (parent) {
      // 获取父元素的计算样式
      const computedStyle = window.getComputedStyle(parent);
      // 检查父元素的 display 属性值是否为 none
      if (computedStyle.display === 'none') {
        return true;
      }
      // 获取下一个父元素
      parent = parent.parentElement;
    }
    return false;
  }

  var PromptVideoList = class PromptVideoList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initButtonEvent();
      this.initLink();
    }
    initLink() {
      const buttons = this.querySelectorAll('ul.button-wrapper button.switch');
      if (!buttons || buttons.length < 1) return;
      const button = buttons[0];
      button.classList.add('active');
    }
    clearActiveStatus() {
      const buttons = this.querySelectorAll('ul.button-wrapper button.switch');
      if (!buttons || buttons.length < 1) return;
      buttons.forEach(function (btn) {
        btn.classList.remove('active');
      });
    }
    initButtonEvent() {
      const ul = this.querySelector('ul.button-wrapper');
      const _this = this;
      ul.addEventListener('click', function (event) {
        if (!event.target.tagName || event.target.tagName.toUpperCase() !== 'SPAN') {
          return;
        }
        _this.clearActiveStatus();
        const button = event.target.parentElement
        button.classList.add('active');
        const video_id = button.getAttribute('data-video-id');
        if (!video_id) return;
        const iframes = _this.querySelectorAll('iframe')
        iframes.forEach(function(iframe){
            iframe.src =  'https://www.youtube.com/embed/' + video_id
        })
      });
    }
  };
  if (!window.customElements.get('prompt-video-list')) {
    window.customElements.define('prompt-video-list', PromptVideoList);
  }

  } catch(e) { console.error(e); }
})();
})();
